/* WAM Hover Image Swap + Pre-order Badge */
(function() {

  function initHoverImages() {
    const cards = document.querySelectorAll('.card-wrapper');
    cards.forEach(function(card) {
      const primaryImg = card.querySelector('.card__media img, .media img');
      if (!primaryImg) return;
      const allImgs = card.querySelectorAll('.card__media img, .media img');
      if (allImgs.length < 2) return;
      const hoverImg = allImgs[1];
      const primarySrc = primaryImg.src;
      const primarySrcset = primaryImg.srcset;
      const hoverSrc = hoverImg.src;
      const hoverSrcset = hoverImg.srcset;
      hoverImg.style.display = 'none';
      primaryImg.style.transition = 'opacity 0.3s ease';
      card.addEventListener('mouseenter', function() {
        if (hoverSrc) {
          primaryImg.style.opacity = '0';
          setTimeout(function() {
            primaryImg.src = hoverSrc;
            if (hoverSrcset) primaryImg.srcset = hoverSrcset;
            primaryImg.style.opacity = '1';
          }, 150);
        }
      });
      card.addEventListener('mouseleave', function() {
        primaryImg.style.opacity = '0';
        setTimeout(function() {
          primaryImg.src = primarySrc;
          if (primarySrcset) primaryImg.srcset = primarySrcset;
          primaryImg.style.opacity = '1';
        }, 150);
      });
    });
  }

  function initPreorderBadges() {
    var cards = document.querySelectorAll('.card-wrapper');
    cards.forEach(function(card) {
      var badges = card.querySelectorAll('.badge');
      badges.forEach(function(badge) {
        if (badge.textContent.trim().toLowerCase().indexOf('sold') !== -1) {
          var link = card.querySelector('a[href*="/products/"]');
          if (link) {
            var href = link.getAttribute('href').split('?')[0];
            fetch(href + '.js')
              .then(function(r) { return r.json(); })
              .then(function(data) {
                if (data.tags && data.tags.indexOf('preorder') !== -1) {
                  badge.textContent = 'PRE-ORDER';
                  badge.removeAttribute('style');
                  badge.style.cssText = 'position: absolute; z-index: 2; display: inline-flex; align-items: center; justify-content: center; width: auto; height: auto; max-width: calc(100% - 2rem); white-space: nowrap; line-height: normal; border-radius: 4rem; padding: 0.5rem 1.2rem; font-size: 1.1rem; font-weight: 500; text-transform: uppercase; background-color: #1a1a1a; color: #ffffff; border: none; box-sizing: border-box;';
                }
              })
              .catch(function() {});
          }
        }
      });
    });
  }

  function init() {
    initHoverImages();
    initPreorderBadges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

})();
